import { render, staticRenderFns } from "./SendMessageTemplateRegister.vue?vue&type=template&id=bd994514&scoped=true&lang=pug"
import script from "./SendMessageTemplateRegister.vue?vue&type=script&lang=ts"
export * from "./SendMessageTemplateRegister.vue?vue&type=script&lang=ts"
import style0 from "./SendMessageTemplateRegister.vue?vue&type=style&index=0&id=bd994514&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bd994514",
  null
  
)

export default component.exports